import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { STATUS, TYPE } from '../store/models/sessionMeetings';

// @todo don't base this on sessionMeetings, make a single find request instead
// @todo add simple model functsion like addParticipant
const useSessionMeeting = ({ id }) => {
  const dispatch = useDispatch();
  const { meetings = [], status } = useSelector(state => state[TYPE]);

  useEffect(() => {
    if (status === STATUS.IDLE) {
      dispatch[TYPE].load();
    }
  }, []);

  return {
    meeting: meetings.find(meeting => meeting.id === id),
  };
};

export default useSessionMeeting;
